import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import Trashcan from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import Dumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import { clearVariation } from '../../../../../redux/form/actions';
import ButtonBorder from '../../partials/ButtonBorder';
import s from './VariationTag.scss';
const VariationTag = ({ deviation, showRemoveIcon })=>{
    const { t } = useTranslation('dreamup');
    const dispatchClearVariation = useAction(clearVariation);
    const handleClick = useCallback(()=>{
        dispatchClearVariation();
    }, [
        dispatchClearVariation
    ]);
    return /*#__PURE__*/ React.createElement(ButtonBorder, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: c(s['button'], showRemoveIcon && s['has-remove-icon']),
        onClick: handleClick,
        "aria-label": t('dreamup.header.input.variationTag.a11y.label'),
        type: "button"
    }, /*#__PURE__*/ React.createElement(Dumbo, {
        deviation: deviation,
        width: 24,
        height: 24,
        useCoverMode: true
    }), showRemoveIcon && /*#__PURE__*/ React.createElement(Close, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), !showRemoveIcon && /*#__PURE__*/ React.createElement("div", {
        className: s['remove-overlay'],
        "aria-hidden": "true"
    }, /*#__PURE__*/ React.createElement(Trashcan, {
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    }))));
};
VariationTag.displayName = 'VariationTag';
export default VariationTag;

//# sourceMappingURL=VariationTag.js.map